import Vue from 'vue';
import numbro from 'numbro';
import helper from '@/libs/helper';

Vue.filter('uppercase', (value) => {
  if (!value) return '';
  const valueString = value.toString();
  return valueString.toUpperCase();
});

Vue.filter('bool', value => (value ? 'Yes' : 'No'));

Vue.filter('currency', (value) => {
  const zeroedValue = '$ 0';
  if (value) {
    try {
      return `$ ${numbro(value).format({ thousandSeparated: true, mantissa: 0 })}`;
    } catch (_) {
      return zeroedValue;
    }
  }
  return zeroedValue;
});

Vue.filter('date', value => helper.formatDate(value));

Vue.filter('optional', value => (value === null || value === undefined ? '-' : value));

Vue.filter('capitalize', str => str.charAt(0).toUpperCase() + str.slice(1));



// WEBPACK FOOTER //
// ./src/start/filters.js